/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
import { Grid } from '@material-ui/core';
import PageTitle from 'components/PageTitle';
import { newPartnerRequest } from 'modules/partners/actions';
import { PartnerFields } from 'modules/partners/interfaces';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { clearingEmptyFieldsObject } from 'utils/helpers';
import FormPartner from '../Form';

interface Props {
  isLoading: boolean;
  newPartnerRequest: (partner: PartnerFields) => void;
}

const NewPartner = ({ isLoading, newPartnerRequest }: Props) => {
  const handleSubmit = values => {
    const filtered = clearingEmptyFieldsObject(values);
    newPartnerRequest(filtered);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageTitle
          title={i18n.t('PARTNER_PAGE.ADD_NEW_PARTNER_KEY')}
          subtitle={i18n.t('PARTNER_PAGE.INIT_INCLUSION_PARTNER_KEY')}
        />
      </Grid>

      <FormPartner isLoading={isLoading} onSubmit={handleSubmit} />
    </Grid>
  );
};

const mapStateToProps = ({ partners: { isLoading } }: ApplicationState) => ({
  isLoading,
});

export default connect(mapStateToProps, { newPartnerRequest })(NewPartner);
